import _extends from '@babel/runtime/helpers/extends';
import React__default, { forwardRef } from 'react';
import PT from 'prop-types';
import styled, { css } from 'styled-components';
import { u as useIsMobile } from '../theme/MobileThemeProvider/useIsMobile-B-VP6bHU.js';
import { i as isMobile } from '../theme/style-mixins/isMobile/isMobile-CGsYoba7.js';
import { a as exclamation, i as infoCircle, e as exclamationTriangle, c as check, t as times } from '../LocalModules/storm-ui-icons/dist/esm/localIcons-EM4gOTGb-B7bhIt-r.js';
import { I as Icon } from '../Icon/Icon-CpzUnHit.js';
import { f as faSpinner } from '../LocalModules/storm-ui-icons/dist/esm/fortawesome-free-solid-svg-icons-B7FqziTJ-C1x4Faml.js';
import { T as Text } from '../Text/Text-nnmbpLTK.js';
import { T as TextButton } from '../Button/TextButton/TextButton-DBMcje7x.js';

const SnackbarContainer = /*#__PURE__*/styled('div').withConfig({
  componentId: "sc-storm-ui-30060407__sc-11vt7q0-0"
})(["background-color:", ";border:", " solid ", ";border-radius:", ";box-shadow:", ";max-width:450px;padding:", ";", ";", ""], ({
  theme
}) => theme.snackbar.backgroundColor, ({
  theme
}) => theme.snackbar.borderWidth, ({
  theme
}) => theme.snackbar.borderColor, ({
  theme
}) => theme.snackbar.borderRadius, ({
  theme
}) => theme.snackbar.boxShadow, ({
  theme
}) => theme.snackbar.padding, ({
  dismissable
}) => dismissable && css(["padding-bottom:14px;"]), isMobile(css(["max-width:100%;padding-bottom:18px;"])));
const ActionContainer = /*#__PURE__*/styled('div').withConfig({
  componentId: "sc-storm-ui-30060407__sc-11vt7q0-1"
})(["display:flex;justify-content:flex-end;margin-top:10px;"]);
const TextContainer = /*#__PURE__*/styled('div').withConfig({
  componentId: "sc-storm-ui-30060407__sc-11vt7q0-2"
})(["flex-grow:1;"]);
const CloseIconButton = /*#__PURE__*/styled(TextButton).withConfig({
  componentId: "sc-storm-ui-30060407__sc-11vt7q0-3"
})(["color:", ";:hover,:active{color:", ";}font-size:16px;margin-block-start:-18px;margin-block-end:-18px;margin-inline-start:0;margin-inline-end:-14px;padding-block-start:18px;padding-block-end:18px;padding-inline-start:14px;padding-inline-end:14px;align-self:flex-start;"], ({
  theme
}) => theme.snackbar.closeButton.color, ({
  theme
}) => theme.snackbar.closeButton.hoverColor);
const IconContainer = /*#__PURE__*/styled('div').withConfig({
  componentId: "sc-storm-ui-30060407__sc-11vt7q0-4"
})(["flex:0 1;margin-inline-end:10px;"]);
const MessageContainer = /*#__PURE__*/styled('div').withConfig({
  componentId: "sc-storm-ui-30060407__sc-11vt7q0-5"
})(["display:flex;flex-direction:row;"]);
const InfoIcon = /*#__PURE__*/styled(Icon).withConfig({
  componentId: "sc-storm-ui-30060407__sc-11vt7q0-6"
})(["color:", ";"], ({
  theme
}) => theme.message.info.iconColor);
InfoIcon.displayName = 'InfoIcon';
const WarningIcon = /*#__PURE__*/styled(Icon).withConfig({
  componentId: "sc-storm-ui-30060407__sc-11vt7q0-7"
})(["color:", ";"], ({
  theme
}) => theme.message.warning.iconColor);
WarningIcon.displayName = 'WarningIcon';
const SuccessIcon = /*#__PURE__*/styled(Icon).withConfig({
  componentId: "sc-storm-ui-30060407__sc-11vt7q0-8"
})(["color:", ";"], ({
  theme
}) => theme.message.success.iconColor);
SuccessIcon.displayName = 'SuccessIcon';
const ErrorIcon = /*#__PURE__*/styled(Icon).withConfig({
  componentId: "sc-storm-ui-30060407__sc-11vt7q0-9"
})(["color:", ";"], ({
  theme
}) => theme.message.error.iconColor);
ErrorIcon.displayName = 'ErrorIcon';
const Snackbar = /*#__PURE__*/forwardRef((props, ref) => {
  const {
    children,
    closeButtonLabel,
    id,
    onClose,
    type,
    ...rest
  } = props;
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, useIsMobile() ? /*#__PURE__*/React__default.createElement(SnackbarContainer, _extends({
    dismissable: !!onClose,
    id: id,
    ref: ref,
    role: onClose ? 'alertdialog' : 'alert'
  }, rest), /*#__PURE__*/React__default.createElement(MessageContainer, null, type !== undefined && /*#__PURE__*/React__default.createElement(IconContainer, null, type === 'error' && /*#__PURE__*/React__default.createElement(ErrorIcon, {
    type: exclamation,
    size: "lg"
  }), type === 'info' && /*#__PURE__*/React__default.createElement(InfoIcon, {
    type: infoCircle,
    size: "lg"
  }), type === 'warning' && /*#__PURE__*/React__default.createElement(WarningIcon, {
    type: exclamationTriangle,
    size: "lg"
  }), type === 'success' && /*#__PURE__*/React__default.createElement(SuccessIcon, {
    type: check,
    size: "lg"
  }), type === 'loading' && /*#__PURE__*/React__default.createElement(Icon, {
    type: faSpinner,
    size: "lg"
  })), /*#__PURE__*/React__default.createElement(TextContainer, null, /*#__PURE__*/React__default.createElement(Text, {
    type: "span"
  }, children)), onClose && /*#__PURE__*/React__default.createElement(CloseIconButton, {
    id: `${id}-dismiss-button-mobile`,
    onClick: onClose
  }, /*#__PURE__*/React__default.createElement(Text, {
    type: "sr-only"
  }, closeButtonLabel), /*#__PURE__*/React__default.createElement(Icon, {
    type: times
  })))) : /*#__PURE__*/React__default.createElement(SnackbarContainer, _extends({
    dismissable: !!onClose,
    id: id,
    ref: ref,
    role: onClose ? 'alertdialog' : 'alert'
  }, rest), /*#__PURE__*/React__default.createElement(MessageContainer, null, type !== undefined && /*#__PURE__*/React__default.createElement(IconContainer, null, type === 'error' && /*#__PURE__*/React__default.createElement(ErrorIcon, {
    type: exclamation,
    size: "lg"
  }), type === 'info' && /*#__PURE__*/React__default.createElement(InfoIcon, {
    type: infoCircle,
    size: "lg"
  }), type === 'warning' && /*#__PURE__*/React__default.createElement(WarningIcon, {
    type: exclamationTriangle,
    size: "lg"
  }), type === 'success' && /*#__PURE__*/React__default.createElement(SuccessIcon, {
    type: check,
    size: "lg"
  }), type === 'loading' && /*#__PURE__*/React__default.createElement(Icon, {
    type: faSpinner,
    size: "lg"
  })), /*#__PURE__*/React__default.createElement(Text, {
    type: "span"
  }, children)), onClose && /*#__PURE__*/React__default.createElement(ActionContainer, null, /*#__PURE__*/React__default.createElement(TextButton, {
    id: `${id}-dismiss-button`,
    onClick: onClose
  }, closeButtonLabel))));
});
Snackbar.propTypes = {
  /**
   * The content of the snackbar.
   */
  children: PT.node.isRequired,
  /**
   * A unique identifier for the snackbar.
   */
  id: PT.string.isRequired,
  /**
   * Displays the type of snackbar: leaving undefined will not show an icon at all.
   */
  type: PT.oneOf(['success', 'error', 'warning', 'info', 'loading']),
  /**
   * Callback that is called when the dismiss button is clicked.
   */
  onClose: PT.func,
  /**
   * Text that appears in the close button. Use this prop to localize the close button.
   */
  closeButtonLabel: PT.string
};
Snackbar.defaultProps = {
  type: undefined,
  onClose: undefined,
  closeButtonLabel: 'Dismiss'
};

export { Snackbar as S };
//# sourceMappingURL=Snackbar-uyI99PGb.js.map
